import videojs from 'video.js';
import StatEval from './stat-eval.js';
import StatXHR from './stat-xhr.js';
import StatTNSHeartbeat from './stat-tns-heartbeat.js';
import StatWebcaster from './stat-webcaster.js';
import StatComscore from './stat-comscore.js';
import StatGa from './stat-ga.js';
import StatGTM from './stat-gtm.js';

const registerPlugin = videojs.registerPlugin || videojs.plugin;

const TYPES = {
	eval: StatEval,
	xhr: StatXHR,
	tns_heartbeat: StatTNSHeartbeat,
	webcaster: StatWebcaster,
	comscore: StatComscore,
	ga: StatGa,
	gtm: StatGTM
};

// Default options for the plugin.
const DEFAULTS = {
	counters: []
};

/**
 * @function stat
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
const stat = function(options) {
	let options_ = videojs.mergeOptions(DEFAULTS, options);
	// In the plugin function, the value of `this` is a video.js `Player` instance.
  	let player = this; // eslint-disable-line no-invalid-this
	
	player.statSpies = [];

	options_.counters.forEach((el) => {
		let type = el.type || 'eval';
		let counter = new TYPES[type](player, el);
		player.statSpies.push(counter);
	});
};

// Register the plugin with video.js.
registerPlugin('stat', stat);

// Include the version number.
stat.VERSION = '__VERSION__';

export default stat;